import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const rapidboardBacklog1Route: InvariantJiraRoute = {
	name: 'rapidboard-backlog',
	path: '/secure/RapidBoard.jspa',
	query: ['rapidView', 'view=(planning|planning.nodetail)'],
};
